module.exports = __webpack_public_path__ + "static/media/arrow_left.df82eb72.svg";